import React, { useState, useEffect } from "react"
import TableHolder from "../components/TableHolder"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost } from "../utils/apiConnector"
import { useDispatch, useSelector } from "react-redux"
import {
  Dimmer,
  Loader,
  Button,
  Card,
  Modal,
  Input,
  Icon,
  Checkbox,
} from "semantic-ui-react"
import {
  invoiceListApi,
  invoiceApi,
  invoiceItemsApi,
  incomingInvoiceListApi,
  xmlInvoiceApi,
  invoiceGetDataApi,
} from "../config/apiUrls"
import ECPSignatureComponent from "../components/ECPSignatureComponent"

const DocumentsPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [documents, setDocuments] = useState([])
  const [incoming, setIncoming] = useState(false)
  const [innerData, setInnerData] = useState([])
  const [modal, setModal] = useState(false)
  const [name, setName] = useState("")
  const [receiver, setReceiver] = useState("")
  const [innerTitle, setInnerTitle] = useState("")
  const [id, setId] = useState("")
  const [xmlToSign, setXmlToSign] = useState("")
  const [token, setToken] = useState("")
  const [docNumber, setDocNumber] = useState("")
  const [data, setData] = useState("")
  const [uuid, setUuid] = useState("")
  const { t } = useTranslation()
  const getData = () => {
    apiGet(invoiceGetDataApi, {})
      .onOk((res) => {
        setIsLoading(true)
        setUuid(res.data.response.uuid)
        setData(res.data.response.data)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getInvoiceList = () => {
    setIsLoading(true)
    apiGet(invoiceListApi, {})
      .onOk((res) => {
        setDocuments(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getIncomingInvoiceList = () => {
    setIsLoading(true)
    apiGet(incomingInvoiceListApi, {})
      .onOk((res) => {
        setDocuments(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getInnerData = (id) => {
    documents.map((q) => {
      if (q.id === id) {
        setId(q.id)
        setInnerData(q.items)
        setInnerTitle(q.name)
      }
    })
  }
  const getXmlData = (callback) => {
    apiGet(xmlInvoiceApi, { invoiceId: id })
      .onOk((res) => {
        setXmlToSign(res.data.response)
        callback(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  const getXmlPreview = () => {
    getXmlData((res) => {
      //let blob = new Blob([String.raw({ raw: res })], {
      let blob = new Blob([res], {
        type: "text/xml",
      })
      let url = URL.createObjectURL(blob)
      window.open(url)
      URL.revokeObjectURL(url)
    })
  }
  const renderNew = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={() => {
            setModal(false)
            setName("")
            setReceiver("")
          }}
          style={{ marginTop: "-40vh", height: "max-content" }}
          size="tiny"
        >
          <Card fluid>
            <Card.Content>
              <h3>{t("New invoice")}</h3>
              <div
                style={{
                  marginTop: 10,
                }}
              >
                <div>
                  <Input
                    // size="small"
                    value={receiver}
                    placeholder={t("BIN of Receiver")}
                    onChange={(e, d) => {
                      setReceiver(d.value)
                    }}
                    type="number"
                  />
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input
                    // size="small"
                    value={name}
                    placeholder={t("Name")}
                    onChange={(e, d) => {
                      setName(d.value)
                    }}
                  />
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input
                    // size="small"
                    value={docNumber}
                    placeholder={t("Номер документа")}
                    onChange={(e, d) => {
                      setDocNumber(d.value)
                    }}
                  />
                </div>
                <div
                  style={{
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    content={t("Submit")}
                    positive
                    onClick={() => {
                      apiPost(invoiceApi, { name, receiver, docNumber })
                        .onOk((res) => {
                          console.log(res.data.response)
                          setIncoming(false)
                          getInvoiceList()
                        })
                        .onFail(() => {})
                        .afterAll(() => {
                          setModal(false)
                          setName("")
                          setReceiver("")
                        })
                        .startSingle()
                    }}
                    disabled={!name || !receiver}
                  />
                </div>
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  useEffect(() => {
    getInvoiceList()
    getData()
    return () => {}
  }, [])
  const config = {
    fname: t("Invoices"),
    data: documents,
    isLoading: () => isLoading,
    headers: [
      { name: "name", title: "Name" },
      { name: "dt", title: "Date" },
      { name: "receiver", title: "Receiver" },
      { name: "sender", title: "Sender" },
    ],
    onClick: getInnerData,
    inner: {
      title: innerTitle,
      fname: innerTitle,
      data: innerData,
      ldata: data,
      luuid: uuid,
      custom: "documents",
      getXmlData: getXmlData,
      getXmlPreview: getXmlPreview,
      token: token,
      setToken: setToken,
      id: id,
      headers: [
        { name: "code", title: "Code" },
        { name: "count", title: "Quantity" },
        { name: "gtin", title: "GTIN" },
      ],
    },
  }
  return (
    <>
      {renderNew()}
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
      <div>
        <h2>{t("Invoices")}</h2>
        <div
          style={{
            marginTop: 10,
            marginBottom: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            positive
            content={t("Create invoice")}
            onClick={() => {
              setModal(true)
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ height: 30 }}>{t("Outbox")}</div>
            <Checkbox
              toggle
              value={incoming}
              onChange={(e, d) => {
                if (d.checked) {
                  getIncomingInvoiceList()
                } else {
                  getInvoiceList()
                }
                setIncoming(d.value)
              }}
              style={{ marginRight: 10, marginLeft: 10 }}
            />
            <div style={{ height: 30 }}>{t("Inbox")}</div>
          </div>
        </div>
        <TableHolder config={config} />
      </div>
    </>
  )
}

export default DocumentsPage
